import React from 'react'
import ScheduleCategoryItem from './ScheduleCategoryItem'
import ItemView from '../../leave_plan_benefits/shared/ItemView'

class ScheduleCategoryView extends React.Component {
  constructor (props) {
    super (props)
    this.setActiveClass = this.setActiveClass.bind(this)
    this.itemForViewMode = this.itemForViewMode.bind(this)
    this.state = {
      show_ready_to_complete_tasks: true,
      show_due_today_tasks: false,
      show_due_later_this_week_tasks: false,
      show_due_later_this_month_tasks: false,
      show_upcoming_tasks: false,
      show_completed_tasks: false
    }
  }

  componentDidMount() {
    if (this.taskId()) {
      const hashString = this.taskId()
      const itemType = hashString.split('-')[0]
      const itemId = hashString.split('-')[1]
      let lookUpField = 'timeline_id'
      if (itemType === 'taskItem') {
        lookUpField = 'leave_item_id'
      }
      const taskItem = this.selectedItem(itemId, lookUpField)
      window.history.replaceState({}, 'LeaveLogic', '/schedules')
      if (taskItem) {
        $.getJSON(`/timeline_items/${taskItem.timeline_id}/fetch_details`, (data) => {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
          this.setActiveClass('timeline_event', itemId, data.description, data.image_url, data.association, lookUpField)
        })
      }
    }
    window.scrollTo(0,0)
  }

  handleBack (state) {
    window.history.pushState(state, state.taskItem.name, this.taskHashId(state.taskItem) )
    window.onpopstate = () => {
      const state = history.state
      if (this.taskId()) {
        this.props.handleItemClick(state.itemType, state.taskItem.item_id, state.description, state.imageUrl, state.association)
      } else {
        this.props.handleItemClick('', '', '', '')
      }
    }
  }

  taskId() {
    return $.getUrlVars(location.search).task
  }

  handleBackClick () {
    history.back()
  }

  setActiveClass (itemType, itemId, description, imageUrl, association, lookUpField, itemFiles) {
    const taskItem = this.selectedItem(itemId, lookUpField)
    if (taskItem) {
      if (this.taskId() !== this.taskHashId(taskItem)) {
        this.handleBack({itemType: itemType, taskItem: taskItem, description: description, imageUrl: imageUrl, association: association})
      }
      $(window).scrollTop(0)
      this.props.handleItemClick(itemType, itemId, description, imageUrl, association, lookUpField, itemFiles)
    }
  }

  taskHashId (taskItem) {
    let task = ''
    if (taskItem.custom_task) {
      task = `customTask-${taskItem.timeline_id}`
    } else {
      task = `taskItem-${taskItem.leave_item_id}`
    }
    return `?task=${task}`
  }

  viewMode () {
    return this.props.display_modal.item_type === 'timeline_event' && this.selectedItem()
  }

  selectedItem (displayItemId, lookUpField) {
    if (!displayItemId) {
      displayItemId = this.props.display_modal.item_id
    }
    if (!lookUpField) {
      lookUpField = this.props.display_modal.lookUpField
    }
    return this.props.data.map((categorizedData) => {
      return categorizedData.data
    }).flatten().filter((data) => {
      return Number(data[lookUpField]) === Number(displayItemId)
    })[0]
  }

  itemForViewMode () {
    const taskItem = this.selectedItem()
    return {
      ...this.selectedItem(),
      image_url: this.props.display_modal.image_url,
      item_type: 'timeline_items',
      item: {
        timeline_id: taskItem.timeline_id,
        helpful: taskItem.helpful
      }
    }
  }

  onHelpfulCheckFromOutside (data) {
    this.props.onHelpfulCheck(this.selectedItem().date, data)
  }

  showableData (data) {
    return data.filter(categorizedData => {
      return this.props.show_all_tasks || this.props[`show_${categorizedData.category.parameterize('_')}_tasks`]
    })
  }

  getCategory (categorizedData) {
    return categorizedData.category
  }

  chevronArrow (category) {
    return (this.state[`show_${category.parameterize('_')}_tasks`]) ? "fa fa-caret-down" : "fa fa-caret-right"
  }

  handleCategoryClick (category) {
    this.setState(prevState => {
      return {
        [`show_${category.parameterize('_')}_tasks`]: !prevState[`show_${category.parameterize('_')}_tasks`]
      }
    })
  }

  filteredCategoryLength (categorizedItems) {
    return categorizedItems.filter((categorized) => {
      return this.checkEventFilter(categorized.event_type) && this.checkHidden(categorized)
    }).length
  }

  checkEventFilter (eventType) {
    return this.props[`show_${eventType.parameterize('_')}_tasks`]
  }

  checkHidden (timelineItem) {
    return timelineItem.visible || this.props.show_hidden_tasks
  }

  _onHelpfulCheck (data) {
    this.props.onHelpfulCheck(null, data)
  }

  renderTaskItems (data) {
    return data.map((categorizedData, key) => {
      return (
        <div key={key}>
          <div className='category-summary-detail'>
            <div className='timeline-header'>
              <a className='category-header' onClick={(e) => this.handleCategoryClick(categorizedData.category)}><h3>
              <i style={{ marginRight: '5px' }} className={this.chevronArrow(categorizedData.category)}></i>
              { this.getCategory(categorizedData) } ({ this.filteredCategoryLength(categorizedData.data) }) </h3> </a>
            </div>
            { this.showCategoryItems(categorizedData.data, key, categorizedData.category) }
          </div>
        </div>
      )
    })
  }

  sortData(timelineItems) {
    let sortOrder = ["Essential", "Recommended", "Information Only"]
    timelineItems.sort((a,b) => {
      let sortByType = sortOrder.indexOf(a.event_type) - sortOrder.indexOf(b.event_type)
      let sortByDate = moment(a.date).toDate() - moment(b.date).toDate()
      let sortByName = a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
      return (sortByType || sortByDate || sortByName)
    })
    return timelineItems
  }

  renderScheduleCategoryItem(timelineItems, category) {
    return this.sortData(timelineItems).map((timelineItem, key) => {
      if (this.checkEventFilter(timelineItem.event_type) && this.checkHidden(timelineItem)) {
        return (
          <ScheduleCategoryItem
            key={key}
            timelineItem={timelineItem}
            onTimelineCheck={this.props.manageTimelineData}
            handleItemClick={this.setActiveClass}
            display_modal={this.props.display_modal}
            categoryClassName={category.parameterize('_')}
            handleJustLookingClick={this.props.handleJustLookingClick}
            onHelpfulCheck={this._onHelpfulCheck.bind(this)}
            handleCustomTaskDelete={this.props.handleCustomTaskDelete}
            handleCustomTaskClick={this.props.handleCustomTaskClick}
            handleCustomTaskChange={this.props.handleCustomTaskChange}
            custom_task_modal={this.props.custom_task_modal}
            disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
          />
        )
      }
    })
  }

  showCategoryItems (timelineItems, key, category) {
    return (this.state[`show_${category.parameterize('_')}_tasks`]) ?
      (
        <div className='timeline-items' key={key}>
          { this.renderScheduleCategoryItem(timelineItems,category) }
        </div>
      ) : <br />
  }

  render () {
    if (this.viewMode()) {
      return (
        <ItemView
          data={this.itemForViewMode()}
          handleCheck={this.handleCheck}
          description={this.props.display_modal.description}
          just_looking={this.props.just_looking}
          handleJustLookingClick={this.props.handleJustLookingClick}
          onHelpfulCheckFromOutside={this.onHelpfulCheckFromOutside.bind(this)}
          handleBackClick={this.handleBackClick}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          itemFiles={this.props.display_modal.itemFiles}
        />
      )
    } else {
      return (
        <div id='category-tab'>
          { this.renderTaskItems(this.props.data) }
        </div>
      )
    }
  }
}

export default ScheduleCategoryView;
